export const GUESTUSER = "guest_user";
export const GUESTRFQ = "GUESTRFQ";
export const GUESTRFQTOTAL = "GUESTRFQTOTAL";
export const GUESTRFQ_STORAGE = "guest_rfq";
export const GUESTFIRSTLOGGEDIN = "GUESTFIRSTLOGGEDIN";
